(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["popup-timing"] && !Shopify.designMode) return;
  try {
    (() => {
    const body = document.body;

    if (!body) {
      return;
    }

    const isProductPage = body.classList.contains('template-product');
    const popupSelector = '[role="dialog"][aria-label="POPUP Form"]';

    const managePopup = () => {
      if (!body.classList.contains('babynor-popup-ready')) {
        if (body.classList.contains('klaviyo-prevent-body-scrolling')) {
          body.classList.remove('klaviyo-prevent-body-scrolling');
        }

        if (isProductPage) {
          body.querySelectorAll(popupSelector).forEach((dialog) => {
            if (dialog.querySelector('.klaviyo-form')) {
              dialog.hidden = true;
            }
          });
        }
      }
    };

    managePopup();

    const observer = new MutationObserver(managePopup);
    observer.observe(body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    if (!isProductPage) {
      window.setTimeout(() => {
        body.classList.add('babynor-popup-ready');

        const dialog = body.querySelector(popupSelector);
        if (dialog) {
          dialog.hidden = false;
          body.classList.add('klaviyo-prevent-body-scrolling');
        }
      }, 20000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
